module.exports = __webpack_public_path__ + "static/img/all.708f66a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/all.png
// module id = e2vJ
// module chunks = 1